import {Fragment, useEffect, useState} from 'react';
import {useLocation} from 'react-router';

import {Button} from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import {SelectButton} from 'primereact/selectbutton';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import {ConfirmDialogService, ToastService, useDataTable, useDialogCrup, useToolbar} from '@iamsoftware/react-hooks';

import {ProductService as Service} from './ProductService';
import {UploadExcel} from "./UploadExcel";

const statuses = [
  {value: 'N', label: 'Đang hoạt động'},
  {value: 'Y', label: 'Ngừng hoạt động'}
];
export const Products = () => {
  const header = 'Danh sách sản phảm/dịch vụ';
  const dataKey = 'productId';
  const [statusId, setStatusId] = useState(statuses[0].value);
  const [taxPercent, setTaxPercent] = useState(null);
  const [checked, setChecked] = useState(false);
  const [displayUploadExcel, setDisplayUploadExcel] = useState(null);

  useEffect(() => {
    if (statusId) {
      reloadLazyData();
    }
  }, [statusId]);

  const tableHeader = (
      <div className="flex align-items-center justify-content-between">
        <span>{header}</span>
        <div>
          <Button label="Thêm" icon="pi pi-plus" severity="success" className="mr-1 mb-1 h-2rem" size="small" onClick={()=>doCreate()}/>
          <Button label="Upload Excel" icon="pi pi-upload" severity="secondary" className="mr-1 mb-1 h-2rem"
                  size="small" onClick={() => setDisplayUploadExcel(Date.now())}/>
          <Button label="Download Excel" icon="pi pi-download" outlined severity="secondary" className="mr-1 mb-1 h-2rem"
                  size="small" onClick={() =>doDownloadExcel()}/>
        </div>
      </div>
  )

  const {render: renderDataTable, reloadLazyData} = useDataTable({
    tableHeader: tableHeader,
    dataKey,
    indexColumnWidth:45,
    columns:[
      {field:'pseudoId', header:'Mã sản phẩm', width: 150, matchMode:'contains',dataType:'custom',customCell(rowData: any): any {
        return <span style={{textDecoration: "underline", color:"blue"}} onDoubleClick={()=>doUpdate(rowData, true)}>{rowData.pseudoId}</span>
        }},
      {field:'productName', header:'Tên sản phẩm', minWidth: 200, matchMode:'contains'},
      {field:'price', header:'Đơn giá', width: 150, matchMode:'numeric', dataType:'number'},
      {field:'taxInPrice', header:'Đã bao gồm thuế', width: 100, matchMode:'contains' ,dataType:'checkbox',},
      {field:'taxPercentage', header:'% thuế', width: 120, matchMode:'numeric',dataType:'number'},
      {field:'taxAmount', header:'Tiền thuế', width: 100, matchMode:'numeric', dataType:'number'},
      {field:'description', header:'Mô tả', minWidth: 200, matchMode:'contains'},
    ],
    actionColumnWidth:90,
    initActions(items: Array<any>) {
      if (items){
        items.forEach(item =>{
          item.actions = [
            {icon: 'pi pi-pencil', title: 'Chỉnh sửa', className: 'p-button-warning', command: () => doUpdate(item, false)},
          ]
          if (item.statusId === 'PRODUCT_DISABLED'){
            item.actions.push({icon: 'pi pi-unlock', title: 'Mở khóa', className: 'p-button-success', command: () => doUnlock(item)})
          }else {
            item.actions.push(
                {icon: 'pi pi-lock', title: 'Khóa', className: 'p-button-danger', command: () => doLock(item)}
            )
          }
        })
      }
    },
    getList(lazyLoadEvent: any): Promise<any> {
      return Service.getList(lazyLoadEvent, {disabled: statusId}).then()
    }
  })


  const {render: renderDialogCrup, create, update,view,  form} = useDialogCrup({
    header:'sản phẩm/dịch vụ',
    dataKey,
    width:'60rem',
    fields:[
      {field:'pseudoId', header:'Mã SP/dịch vụ', required:true, className:'md:col-4'},
      {field:'productName', header:'Tên SP/dịch vụ', required:true, className:'md:col-8'},
      {field:'price', header:'Đơn giá', required:true, className:'md:col-4',type:'InputNumber'},
      {type:'custom',  className:'md:col-4',body: <Fragment>
          <div>Thuế suất</div>
          <div className="p-inputgroup mt-2">
            <InputNumber value={taxPercent} onChange={(e) => setTaxPercent(e.value)} min={0} max={100}/>
            <span className="p-inputgroup-addon">
            <i className="pi pi-percentage"/>
          </span>
          </div>
        </Fragment>
      },
      {type:'custom', className:'md:col-3',body:<Fragment>
          <div className="flex mt-5 ml-5">
            <Checkbox onChange={e =>{setChecked(e.checked)}} checked={checked}></Checkbox>
            <span className="ml-2 mt-1">Giá đã bao gồm thuế</span>
          </div>
        </Fragment>},
      {field:'description', header:'Mô tả', className:'md:col-12'}
    ],
    createItem(item: any): Promise<any> {
      return Service.create(inject(item)).then()
    },
    updateItem(id: string, item: any): Promise<any> {
      return Service.update(id,inject(item))
    },
    reloadLazyData,
  })


  const doCreate = () =>{
    setTaxPercent(null);
    setChecked(false);
    create()
  }

  const doUpdate = (item: any, doView:boolean) =>{
    if (item[dataKey]){
      Service.get(item[dataKey]).then(data =>{
        if (data.taxInPrice === 'Y'){
          setChecked(true)
        }
        setTaxPercent(data?.taxPercentage)
        if (doView === true){
          view(data)
        }else {
          update(data)
        }
      })
    }
  }

  const inject = (item) =>{
    if (checked === true){
      item.taxInPrice = 'Y'
    }else {
      item.taxInPrice = 'N'
    }
    if (taxPercent){
      item.taxPercentage = taxPercent;
    }else {
      item.taxPercentage = 0
    }
    return item
  }

  const doLock = (item) =>{
    if (item[dataKey]){
      ConfirmDialogService.confirm('Khóa sản phẩm/dịch vụ','Bạn xác nhận khóa sản phẩm/dịch vụ này?',()=>{
        Service.disable(item[dataKey]).then(()=>{
          ToastService.success();
          reloadLazyData();
        })
      })
    }
  }

  const doUnlock = (item) =>{
    if (item[dataKey]){
      ConfirmDialogService.confirm('Mở khóa sản phẩm/dịch vụ','Bạn xác nhận mở khóa sản phẩm/dịch vụ này?',()=>{
        Service.enable(item[dataKey]).then(()=>{
          ToastService.success();
          reloadLazyData();
        })
      })
    }
  }

  const doDownloadExcel = () => {
    window.open(`${Service.baseURL}/${Service.entity}/download-excel`)
  }


  return (
      <div className="grid">
        <div className="col-12 pb-0">
          <SelectButton value={statusId} options={statuses} onChange={e => setStatusId(e.value)}/>
        </div>
        <div className="col-12 py-0" style={{maxHeight: 'calc(100vh - 12rem)'}}>
        {renderDataTable()}
      </div>
      {renderDialogCrup()}
        <UploadExcel display={displayUploadExcel} setDisplay={setDisplayUploadExcel} reloadLazyData={reloadLazyData}/>
    </div>
  );
}